<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="noind" id="epigraph"><a id="start"><i>We do not ride on the railroad; it rides upon us. Did you ever think what those sleepers are that underlie the railroad? Each one is a man, an Irishman, or a Yankee man.</i></a></p><a id="start">
</a></blockquote><a id="start">
<p class="hang4">—Thoreau</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-start.vue?1d099058